module.exports = __webpack_public_path__ + "img/Z71_13.2600ec99.jpg";